import { render } from "./rulesPage.vue?vue&type=template&id=087af5f2&scoped=true"
import script from "./rulesPage.vue?vue&type=script&lang=js"
export * from "./rulesPage.vue?vue&type=script&lang=js"

import "./rulesPage.vue?vue&type=style&index=0&id=087af5f2&scoped=true&lang=css"

import exportComponent from "/Users/hamzaassif/Work/detect-front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-087af5f2"]])

export default __exports__